import { initialErrors } from "../Constants/Shipments.constants";
import { Types } from "../Constants/Types";
import ShipmentType from "../Interfaces/shipments.interface";

const ShipmentsReducer = (state: ShipmentType['status'] = { 
    shipment: undefined,
    shipments: [],
    lshipments: false,
    lshipment: false,
    pages: 0,
    total: 0,
    error: initialErrors,
    shipmentStatusCount: [],
    lshipmentStatus: false
  },
  action: ShipmentType['action']
) => {
  switch (action.type) {
    case Types.FETCH_SHIPMENTS:
      return {...state, shipments: action.payload, pages: action.pages, total: action.total};

    case Types.FETCH_SHIPMENT:
      return {...state, shipment: action.payload};

    case Types.CREATE_SHIPMENT:
      return {...state, shipment: action.payload};

    case Types.UPDATE_SHIPMENT:
      return {
        ...state, 
        shipment: action.payload,
        shipments: state.shipments.map(ship => 
          ship._id === action.payload._id ? action.payload : ship
        )
      };

    case Types.FETCH_SHIPMENT_STATUS:
      return {...state, shipmentStatusCount: action.payload};

    case Types.START_SHIPMENT_STATUS:
      return {...state, lshipmentStatus: true};

    case Types.END_SHIPMENT_STATUS:
      return {...state, lshipmentStatus: false};

    case Types.START_SHIPMENTS:
      return {...state, lshipments: true};

    case Types.END_SHIPMENTS:
      return {...state, lshipments: false};

    case Types.START_SHIPMENT:
      return {...state, lshipment: true};

    case Types.END_SHIPMENT:
      return {...state, lshipment: false};

    case Types.ERROR_SHIPMENT:
      return {
        ...state, 
        error: action?.payload 
          ? {...state.error, [action?.field!]: action.payload} 
          : {...state.error, [action?.field!]: null}
      };

    case Types.RESET_SHIPMENT:
      return {...state, error: initialErrors};

    default: 
      return state;
  }
};

export default ShipmentsReducer; 